import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { flexFillParent, useAddonStyles } from 'kineticUtils';

const useContentHeaderStyles = makeStyles(({ spacing }) => {
  const { addons } = useAddonStyles(spacing);
  return createStyles({
    header: {
      ...flexFillParent,
      alignItems: 'center',
    },
    addons,
  });
});

export default useContentHeaderStyles;
